/* eslint-disable react-hooks/rules-of-hooks */

import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { SOCKET_EVENT } from "../data/socket.enum";
import { useRecord } from "../customHook/useRecord";
import { useRoomConnection } from "../customHook/useRoomConnection";
import { setCheck } from "../store/actions/userStateAction";
import { addSentryBreadcrumb } from "./sentryContext";

const parseExamMessage = (message) => {
  if (typeof message === "string") {
    return { status: message, updatedAt: null, seq: null };
  }

  if (!message || typeof message !== "object") {
    return { status: null, updatedAt: null, seq: null };
  }

  const payload =
    message.message && typeof message.message === "object"
      ? message.message
      : message;

  return {
    status:
      typeof message.message === "string"
        ? message.message
        : payload.message || payload.status || payload.state || null,
    updatedAt:
      payload.updatedAt || payload.sentAt || payload.timestamp || null,
    seq: payload.seq || payload.sequence || null,
  };
};

export const receiveStatus = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const userInfo = useSelector((state) => state.userInfo);
  const { stopRecordHandler } = useRecord();
  const lastControlSeq = useRef(null);
  const lastControlUpdatedAt = useRef(null);

  const { socket } = useRoomConnection();
  //   const { pendingModal, disconnectMobileModal } = useSelector(
  //     (state) => state.modalAction,
  //   );

  //퇴장, 강제 퇴장
  //   useEffect(() => {
  //     if (Object.keys(socket).length === 0) return;
  //     socket?.on(SOCKET_EVENT.USER_WAITING, (message) => {
  //       if (message === "Y") {
  //         //퇴장 대기 상태 waiting
  //         dispatch({ type: WAITING_MODAL, data: "waiting" });
  //       } else {
  //         dispatch({ type: WAITING_MODAL, data: false });
  //       }
  //     });

  //     socket?.on(SOCKET_EVENT.USER_KICK, (message) => {
  //       dispatch({
  //         type: KICK_MODAL_ON,
  //         msg: message,
  //       });
  //       dispatch({ type: TIME_STOP, data: true });
  //       stopRecordHandler();
  //     });

  //     return () => {
  //       socket.off(SOCKET_EVENT.USER_KICK);
  //       socket.off(SOCKET_EVENT.USER_WAITING);
  //     };
  //   }, []);

  //감독관 일시정지 재생 펜딩
  useEffect(() => {
    if (Object.keys(socket).length === 0) return;
    const isMainExam = router.pathname === "/main" && !userInfo.isPreCheck;

    socket?.on(SOCKET_EVENT.USER_EXAM, (message) => {
      if (!isMainExam) {
        return;
      }

      const { status, updatedAt, seq } = parseExamMessage(message);
      const normalizedSeq = seq === null ? null : Number(seq);
      const normalizedUpdatedAt =
        updatedAt === null ? null : Number(updatedAt);

      if (!status) {
        addSentryBreadcrumb({
          category: "exam-control",
          message: "ignore empty exam control",
          level: "warning",
          data: { message },
        });
        return;
      }

      if (status !== "PAUSE" && status !== "PLAY") {
        addSentryBreadcrumb({
          category: "exam-control",
          message: "ignore unsupported exam control",
          data: { status },
        });
        return;
      }

      if (
        normalizedSeq !== null &&
        !Number.isNaN(normalizedSeq) &&
        lastControlSeq.current !== null
      ) {
        if (normalizedSeq < lastControlSeq.current) {
          addSentryBreadcrumb({
            category: "exam-control",
            message: "ignore stale exam control by sequence",
            level: "warning",
            data: { status, seq },
          });
          return;
        }
      }

      if (
        normalizedUpdatedAt !== null &&
        !Number.isNaN(normalizedUpdatedAt) &&
        lastControlUpdatedAt.current !== null
      ) {
        if (normalizedUpdatedAt < lastControlUpdatedAt.current) {
          addSentryBreadcrumb({
            category: "exam-control",
            message: "ignore stale exam control by updatedAt",
            level: "warning",
            data: { status, updatedAt },
          });
          return;
        }
      }

      if (normalizedSeq !== null && !Number.isNaN(normalizedSeq)) {
        lastControlSeq.current = normalizedSeq;
      }
      if (normalizedUpdatedAt !== null && !Number.isNaN(normalizedUpdatedAt)) {
        lastControlUpdatedAt.current = normalizedUpdatedAt;
      }

      if (status === "PAUSE") {
        dispatch(setCheck(false));
      } else if (status === "PLAY") {
        dispatch(setCheck(true));
      }
    });

    return () => {
      socket.off(SOCKET_EVENT.USER_EXAM);
    };
  }, [socket, router.pathname, userInfo.isPreCheck]);
};
